import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKCarousel from '@tk/components/tk.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKSelection from '@tk/controls/tk.selection';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';
import TKTable from '@tk/components/tk.table';
import GTASearch from '@/controls/gta.search';
import GTAHeader from '@/components/gta.header';
import OpenOffers from '@/components/gta.open.offers';
import GTABarcodeScanner from '@/components/gta.barcode.scanner';
import GTADialog from '@/components/gta.dialog';
import GTASelection from '@/controls/gta.selection';
import GTANavigationSidebar from '@/components/gta.navigation.sidebar';

import '@splidejs/splide/dist/css/splide.min.css';
import 'tippy.js/dist/tippy.css';

import '@css/modules/general.css';

export default class General extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: GTAHeader },
            { name: 'open-offers', constructor: OpenOffers },
            { name: 'tk-nav-sidebar', constructor: GTANavigationSidebar },
            { name: 'gta-search', constructor: GTASearch },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'gta-dialog', constructor: GTADialog },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
            { name: 'gta-barcode-scanner', constructor: GTABarcodeScanner },
            { name: 'gta-selection', constructor: GTASelection },
            { name: 'tk-table', constructor: TKTable },
        ]);
    }
}

// eslint-disable-next-line no-new
new General();
